/* eslint-disable max-len */
/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-restricted-properties */
import DateTime from '../components/Utils/DateTime/DateTime';

export const phoneRegExp = /^(\98|0)?9\d{9}$/;

export const changeJalaliFormat = (birthday: string) => {
  const yearSlice = birthday?.slice(0, 4);
  const monthSlice = birthday?.slice(4, 6);
  const daySlice = birthday?.slice(6, 8);
  return birthday ? `${yearSlice}/${monthSlice}/${daySlice}` : null;
};

export const computeDateInJalaliFormat = (createdAt: string) => {
  if (createdAt) {
    const createAtDate = DateTime.stringToDate(createdAt);
    const createAtJalaliDate = DateTime.gregorianToJalali(createAtDate.year, createAtDate.month, createAtDate.day);
    const weekDayNumber =
      DateTime.getJalaliMonthFirstWeekDay(createAtJalaliDate.year, createAtJalaliDate.month, createAtJalaliDate.day);
    return `${DateTime.weekNames[weekDayNumber]} ${createAtJalaliDate.day}
             ${DateTime.monthNames[createAtJalaliDate.month - 1]}`;
  }
};

export const computeOnlyDateInJalali = (createdAt: string) => {
  if (createdAt) {
    const createAtDate = DateTime.stringToDate(createdAt);
    const createAtJalaliDate = DateTime.gregorianToJalali(createAtDate.year, createAtDate.month, createAtDate.day);
    return `${createAtJalaliDate.year}/${createAtJalaliDate.month}/${createAtJalaliDate.day}`;
  }
};

export const computeCustomDateWithTime = (createdAt: string) => {
  if (createdAt) {
    const createAtDate = DateTime.stringToDate(createdAt);
    const createAtJalaliDate = DateTime.gregorianToJalali(createAtDate.year, createAtDate.month, createAtDate.day);

    const hour = createAtDate.hour.toString().length === 1 ? `0${createAtDate.hour}` : createAtDate.hour;
    const minute = createAtDate.minute.toString().length === 1 ? `0${createAtDate.minute}` : createAtDate.minute;
    return {
      date: `${createAtJalaliDate.year}/${createAtJalaliDate.month}/${createAtJalaliDate.day}`,
      time: `${hour}:${minute}`,
    };
  }
};

export const computeTimeInJalaliFormat = (createdAt: string) => {
  if (createdAt) {
    const createAtDate = DateTime.stringToDate(createdAt);
    return `${createAtDate.hour}:${createAtDate.minute}`;
  }
};

export const convertFormatDate = (date: string) => {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return `${[year, month, day].join('-')}T00:00:00.343Z`;
};

export const convertFormatDateWithTime = (date: string) => {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();
  let hours = `${d.getHours()}`;
  let minutes = `${d.getMinutes()}`;
  let seconds = `${d.getSeconds()}`;

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;
  if (hours.length < 2) hours = `0${hours}`;
  if (minutes.length < 2) minutes = `0${minutes}`;
  if (seconds.length < 2) seconds = `0${seconds}`;

  return `${[year, month, day].join('-')}T${hours}:${minutes}:${seconds}.343Z`;
};

export const commaSeparateNumber = (val: any) => {
  if (val) {
    while (/(\d+)(\d{3})/.test(val.toString())) {
      // eslint-disable-next-line no-param-reassign,no-useless-concat
      val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
    }
  }
  return val;
};

export const timeFormatter = (currentTime: any, separator: string, locale: string) => {
  const options = [{ weekday: 'long' }, { day: 'numeric' }, { month: 'short' }, { year: 'numeric' }];

  function format(m: any) {
    const f = new Intl.DateTimeFormat(locale, m);
    return f.format(currentTime);
  }
  return options.map(format).join(separator);
};

export const dateTimeFormatter = (locale: string) => {
  const formatTime = timeFormatter(new Date(), ' ', locale);
  const day = formatTime.substr(0, formatTime.indexOf(' '));
  const formattedDateTime = (day).concat(`،${formatTime.split(day)[1]}`);
  return formattedDateTime;
  // const formattedGregorian = timeFormatter(new Date(), ' ', 'en');
};

const formatTime = (value: number) => `${value.toString().length === 1 ? '01' : value}`;

export const computeDateInJalali = (createdAt: string) => {
  if (createdAt) {
    const createAtDate = DateTime.stringToDate(createdAt);
    const createAtJalaliDate = DateTime.gregorianToJalali(createAtDate.year, createAtDate.month, createAtDate.day);
    return `${createAtJalaliDate.year}/${createAtJalaliDate.month}/${createAtJalaliDate.day}`;
  }
};

export const getCurrentTime = () => {
  const today = new Date();
  return `${formatTime(today.getHours())}:${formatTime(today.getMinutes())}:${formatTime(today.getSeconds())}`;
};

export const convertNumbers2English = (string: any) => {
  return string?.replace(/[\u0660-\u0669]/g, (c: any) => {
    return c.charCodeAt(0) - 0x0660;
  }).replace(/[\u06f0-\u06f9]/g, (c: any) => {
    return c.charCodeAt(0) - 0x06f0;
  });
};

export const copyToClipboard = (value: any) => {
  const input = document.createElement('textarea');
  input.innerHTML = value;
  document.body.appendChild(input);
  input.select();
  const result = document.execCommand('copy');
  document.body.removeChild(input);
  return result;
};

export const isObjectEmpty = (obj: any) => {
  return Object.keys(obj).length === 0;
};

export const convertDateTime = (dateTime: string) => {
  const date = new Date(dateTime).toLocaleString('fa');
  return date.replace('،', ' -');
};

export const convertMinutesToHumanReadable = (minutes?: number): string => {
  if (!minutes) {
    return null;
  }
  const hour = Math.floor(minutes / 60);
  const hourStr = hour ? `${hour} ساعت ` : '';
  const min = minutes % 60;
  const minStr = min ? `${min} دقیقه ` : '';
  return `${hourStr}${minStr}`;
};

export const computeDateInJalaliWithMonthsName = (_dateTime: string) => {
  if (_dateTime) {
    const date = new Date(_dateTime).toLocaleString('fa', {
      // year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
    return date.replace('،', ' ساعت');
  }
};

export const toFixed = (x: any, y: number) => {
  return Number.parseFloat(x).toFixed(y);
};

export const isEmpty = (obj: any) => {
  for (const prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }
  return JSON.stringify(obj) === JSON.stringify({});
};

export const removeFalsyFromObject = (obj: any) => {
  const newObj = {};
  Object.keys(obj).forEach((prop) => {
    // @ts-ignore
    if (obj[prop]) { newObj[prop] = obj[prop]; }
  });
  return newObj;
};

export const _arrayBufferToBase64 = (buffer: any) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return `data:image/jpeg;base64,${window.btoa(binary)}`;
};

export const removeParameterFromUrl = (url: string, parameter: string) => {
  return url
    .replace(new RegExp(`[?&]${ parameter }=[^&#](#.)?$`), '$1')
    .replace(new RegExp(`([?&])${ parameter }=[^&]*&`), '$1');
};

export const hasNumber = (string:string) => {
  return /\d/.test(string);
};

export const toHoursAndMinutes = (time:number) => {
  const hours = Math.floor(time / 60);
  const minutes = time % 60;
  return time > 0 ? `${hours > 0 ? `${hours} ساعت` : ''} ${minutes > 0 ? `${minutes} دقیقه` : ''}` : '0';
};

export const isNumber = (string:string) => {
  return /^\d+$/.test(string);
};

export const getMimeTypeFromExtension = (fileExtension: string) => {
  let mimeType;
  switch (fileExtension) {
    case 'png':
    case 'bmp':
    case 'tiff':
    case 'webp':
    case 'gif':
    case 'avif':
      mimeType = `image/${fileExtension}`;
      break;
    case 'jpeg':
    case 'jpg':
      mimeType = 'image/jpeg';
      break;
    case 'tif':
      mimeType = 'image/tiff';
      break;
    case 'svg':
      mimeType = 'image/svg+xml';
      break;
    case 'csv':
      mimeType = 'text/csv';
      break;
    case 'txt':
      mimeType = 'text/plain';
      break;
    case 'doc':
      mimeType = 'application/msword';
      break;
    case 'docx':
      mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      break;
    case 'xls':
      mimeType = 'application/vnd.ms-excel';
      break;
    case 'xlsx':
      mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      break;
    case 'zip':
    case 'pdf':
      mimeType = `application/${fileExtension}`;
      break;
    case '7z':
      mimeType = 'application/x-7z-compressed';
      break;
    case 'rar':
      mimeType = 'application/vnd.rar';
      break;
    case 'mp3':
      mimeType = 'audio/mpeg';
      break;
    case 'mp4':
    case 'mpeg':
      mimeType = `video/${fileExtension}`;
      break;
    default:
      mimeType = '*/*';
      break;
  }
  return mimeType;
};

export const arrayBufferToDataUrl = (mimeType: string, buffer: any) => {
  if (!buffer) {
    return null;
  }
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return `data:${mimeType};base64,${window.btoa(binary)}`;
};

export const downloadFile = (dataUrl: any, filename:string) => {
  const link = document.createElement('a');
  link.href = dataUrl;
  link.download = filename;
  link.click();
};

export const concatenateStrings = (...args: (string | null | undefined)[]) => args.flatMap((arg) => ((arg != null && arg.trim() !== '') ? [arg] : [])).join(' ').trim();
